import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useRelevantWorkingLists } from '../../../hooks/utils/useRelevantWorkingLists';
import { useSearchTabActions, useWorkingListActions } from '../../../store';
import { MenuNode } from './menuNode';
import styles from './styles.module.css';

export function useWorkingListsNodes(marketCountry: string): MenuNode[] {
  const navigate = useNavigate();
  const { selectTab } = useSearchTabActions();

  const lists = useRelevantWorkingLists(marketCountry);
  const { selectList } = useWorkingListActions();

  const nodes = useMemo<MenuNode[]>(
    () =>
      lists.data?.map((list) => ({
        id: 'working-list/' + list.ID,
        label: list.Name,
        nodeData: {
          onClick: () => {
            selectList(list.ID);
            selectTab('working-list');
            navigate('/search');
          },
        },
      })) ?? [],
    [lists.data, selectList, selectTab, navigate],
  );

  return useMemo(
    () => [
      {
        id: '9AC4B17A-FC01-44FA-A501-B980D253B073',
        hasCaret: true,
        icon: 'panel-table',
        label: 'Working lists',
        className: styles.clickable,
        secondaryLabel: `(${lists.data?.length ?? 0})`,
        childNodes: nodes,
      },
    ],
    [nodes, lists.data?.length],
  );
}
